var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapBallad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3139)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#1DDFEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3139",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 38,
    width: 36,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39,
    y: 38,
    width: 36,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7382 56.8015C83.1674 56.8015 70.0859 34.1439 58.8669 53.5684C70.0771 34.1439 43.9141 34.1439 55.1331 53.5684C43.9229 34.1439 30.8414 56.8015 53.2618 56.8015C30.8326 56.8015 43.9141 79.4591 55.1331 60.0345C43.9229 79.4591 70.0859 79.4591 58.8669 60.0345C70.0771 79.4679 83.1586 56.8015 60.7382 56.8015Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.7382 56.8015C83.1674 56.8015 70.0859 34.1439 58.8669 53.5684C70.0771 34.1439 43.9141 34.1439 55.1331 53.5684C43.9229 34.1439 30.8414 56.8015 53.2618 56.8015C30.8326 56.8015 43.9141 79.4591 55.1331 60.0345C43.9229 79.4591 70.0859 79.4591 58.8669 60.0345C70.0771 79.4679 83.1586 56.8015 60.7382 56.8015Z",
    fill: "#1DDFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7382 56.8015C83.1674 56.8015 70.0859 34.1439 58.8669 53.5684C70.0771 34.1439 43.9141 34.1439 55.1331 53.5684C43.9229 34.1439 30.8414 56.8015 53.2618 56.8015C30.8326 56.8015 43.9141 79.4591 55.1331 60.0345C43.9229 79.4591 70.0859 79.4591 58.8669 60.0345C70.0771 79.4679 83.1586 56.8015 60.7382 56.8015Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3139)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3139",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3139"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3139",
    x: 35.9998,
    y: 38,
    width: 42.0005,
    height: 45.603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3139",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapBallad);
export default __webpack_public_path__ + "static/media/glowing_map_ballad.31c419cf1ff7ba7817f9bc38e0d24da7.svg";
export { ForwardRef as ReactComponent };